import {
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Row,
  Select,
  Switch,
} from 'antd'
import configuration from 'modules/configuration'
import { generateMessageError, generateSelectOptions } from 'modules/core/utils'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const SapCompanyCreateModal = ({
  visible,
  onClose,
  onRefetch,
  createSapCompany,
  allDimensionsValuesCompany,
}) => {
  const [isSaving, setIsSaving] = useState(false)
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const companyOptions = useMemo(
    () =>
      generateSelectOptions({
        options: (allDimensionsValuesCompany || []).map((dim) => ({
          ...dim,
          id: dim.code_destination,
          name: dim.name_destination,
          code: dim.code_destination,
        })),
      }),
    [allDimensionsValuesCompany],
  )

  const onCancel = () => {
    form.resetFields()
    onClose()
  }

  const onConfirm = () => {
    form.validateFields().then((values) => {
      setIsSaving(true)
      createSapCompany(values)
        .then(() =>
          onRefetch().then(() => {
            message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
            setIsSaving(false)
            onCancel()
          }),
        )
        .catch((error) => {
          setIsSaving(false)
          onCancel()
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error),
            duration: 0,
          })
        })
    })
  }

  return (
    <Modal
      title={t('CONFIG_SAP_COMPANY_CREATE_MODAL_TITLE')}
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={t('ACTION_CREATE')}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
      centered
      forceRender
      destroyOnClose
    >
      <Form form={form} layout="vertical" initialValues={{ active: false }}>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item
              label={t('CONFIG_SAP_COMPANY_FIELD_COMPANY_CODE')}
              name="company_code"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Select
                options={companyOptions}
                placeholder={t('ACTION_SELECT')}
                showSearch
                optionFilterProp="title"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('CONFIG_SAP_COMPANY_FIELD_COMPANY_DB')}
              name="company_db"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input placeholder={t('CONFIG_SAP_COMPANY_FIELD_COMPANY_DB')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('CONFIG_SAP_COMPANY_FIELD_USER_NAME')}
              name="user_name"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input placeholder={t('CONFIG_SAP_COMPANY_FIELD_USER_NAME')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('CONFIG_SAP_COMPANY_FIELD_PASSWORD')}
              name="password"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('CONFIG_SAP_COMPANY_FIELD_SERIE')}
              name="serie"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <InputNumber precision={0} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('CONFIG_SAP_COMPANY_FIELD_ACTIVE')}
              name="active"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const mapDispatchToProps = {
  createSapCompany: configuration.actions.createSapCompany,
}

export default connect(null, mapDispatchToProps)(SapCompanyCreateModal)
